






























import { Vue, Component } from "@/shared/vuepack";
import ResourcesNavigation from "@/employer/components/resources/ResourcesNavigation.vue";

@Component({
  components: {
    ResourcesNavigation
  }
})
export default class EmployerCommunicationsKit extends Vue {
  employerCommunicationsKitFrameUrl = "https://www.bendhsa.com/ercomkit#intro";
}
